import { render } from "./NetworkConfiguration.vue?vue&type=template&id=c96c77b8&scoped=true"
import script from "./NetworkConfiguration.vue?vue&type=script&lang=js"
export * from "./NetworkConfiguration.vue?vue&type=script&lang=js"

import "./NetworkConfiguration.vue?vue&type=style&index=0&id=c96c77b8&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96c77b8"]])

export default __exports__